import { createClient } from '@/shared/api';
import STOP_HOLTER_STUDY_PROCESSING from '@/entities/study/api/mutations/stopHolterStudyProcessing';
import type {
  StopHolterStudyProcessingMutation,
  StopHolterStudyProcessingMutationVariables,
} from '@/shared/api/generated/graphql';

export type StopHolterStudyProcessingResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the HolterStudyProcessingInput GraphQL input once its server-side shape is documented
/**
 * Stops holter processing already running for a study. Runs the stop mutation and returns its payload on success, throwing the server message otherwise.
 *
 * @param input - Mutation input identifying the study to stop.
 * @returns A promise resolving to the stopHolterStudyProcessing result.
 */
const handleStopHolterStudyProcessing = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    StopHolterStudyProcessingMutation,
    StopHolterStudyProcessingMutationVariables
  >({
    mutation: STOP_HOLTER_STUDY_PROCESSING,
    variables: { input },
  });
  if (result?.data?.stopHolterStudyProcessing?.isSuccess) {
    return result?.data?.stopHolterStudyProcessing;
  }
  throw new Error(result?.data?.stopHolterStudyProcessing?.message);
};

export default handleStopHolterStudyProcessing;
